export default __webpack_public_path__ + "static/media/scholoarship.1dfac042.jpg";